import type { MembershipTier } from '@/lib/types';

export const DEFAULT_MEMBERSHIP_TIER: MembershipTier = 'free';

export const ACTIVE_MEMBERSHIP_TIERS: MembershipTier[] = [
  'paid',
  'private_member',
  'private_signature',
  'private_concierge',
];

export const MEMBERSHIP_TIER_LABELS: Record<MembershipTier, string> = {
  free: 'Free',
  private_member: 'Private Member',
  private_signature: 'Private Signature',
  private_concierge: 'Private Concierge',
  paid: 'Private Member',
};

export const MEMBERSHIP_TIER_BENEFITS: Partial<Record<MembershipTier, string[]>> = {
  private_member: [
    'All products & services at market price',
    'Hotel booking platform + curated experiences',
    'Personal lifestyle advisory (48hr response)',
  ],
  private_signature: [
    'All products & services at market price',
    'Full access to hotel platform + experiences',
    'Lifestyle & concierge support (09:00–17:00)',
  ],
  private_concierge: [
    'All products & services at market price',
    '24/7 priority concierge & lifestyle support',
    'Dedicated personal luxury advisor',
  ],
  paid: [
    'All products & services at market price',
    'Hotel booking platform + curated experiences',
    'Personal lifestyle advisory (48hr response)',
  ],
};

export function getMembershipLabel(tier?: MembershipTier | null): string {
  return MEMBERSHIP_TIER_LABELS[tier || DEFAULT_MEMBERSHIP_TIER];
}

export function getMembershipBenefits(tier?: MembershipTier | null): string[] {
  return MEMBERSHIP_TIER_BENEFITS[tier || DEFAULT_MEMBERSHIP_TIER] || [];
}

export function isPaidLikeMembership(tier?: MembershipTier | null): boolean {
  return !!tier && ACTIVE_MEMBERSHIP_TIERS.includes(tier);
}

